<template>
	<v-radio
		v-bind="$attrs"
		color="primary"
	>
		<template #label="{ label }">
			<translate :class="`text-${color} `">
				{{ label }}
			</translate>
		</template>
	</v-radio>
</template>

<script>

/**
 * Useful when using rules inside your text field to get errors properly translated
 */
export default {
	name: 'RadioButton',
	props: {
		hasError: {
			type: Boolean,
			default: false,
			required: false,
		}
	},

	computed: {
		color () {
			return this.hasError ? 'error' : 'black';
		}
	}
};
</script>
